import { render, staticRenderFns } from "./gs-country-lookup.vue?vue&type=template&id=fcca9ce8"
import script from "./gs-country-lookup.vue?vue&type=script&lang=ts"
export * from "./gs-country-lookup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports